<template>
    <div class="col">

        <div id="main"
             class="col-main">

            <div class="row no-gutters row-main justify-content-center">

                <div class="col-12 col-lg-10 bg-white">

                    <div class="row no-gutters justify-content-center">
                        <div class="col-12 col-lg-9">
                            <h2 class="section-title">Ealing Trailfinders Cricket Club – Photo Gallery</h2>
                        </div>

                        <div class="col-12 col-lg-12">

                            <div class="row card-row justify-content-start">

                                <!-- always use landscape view image for gallery thumbnail -->
                                <div v-for="image of images"
                                     v-bind:key="image._id"
                                     class="card-col col-12 col-sm-6 col-md-4">
                                    <figure class="figure zoom"
                                            data-toggle="modal"
                                            data-target="#gallery01-Modal">
                                        <expandable-image :src="image.image"
                                                          :alt="image.caption"
                                                          class="img-fit"/>
                                        <figcaption class="figure-caption text-dark text-strong">{{image.caption}}
                                        </figcaption>
                                    </figure>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</template>
<script>
    import {fetchGallery} from "@/services/api";

    export default {
        data() {
            return {
                images: []
            }
        },
        created() {
            this.fetchList();
        },
        methods: {
            fetchList() {
                fetchGallery()
                    .then(response => {

                        for (let value of response) {
                            if (value.status === 'Live') this.images.push(value)
                        }
                    })
            },
        }
    }
</script>